import React, { useEffect, useState } from 'react'
import { Container, Table, Button, Form } from "react-bootstrap";
import { useCRMDataContext } from '../../Context/CRMContext';
import { Link } from 'react-router-dom';
import { FaPencilAlt, FaCheck } from "react-icons/fa";
import { postedRawLeads } from '../../Api/CRMAPI/rawleads'
// import { FaCheck } from "react-icons/fa6";
import { useAuth } from '../../Context/AuthContext';
import { toast } from "react-toastify";

const RawLeadsMapping = () => {
     const { user } = useAuth();
    const { leadSource,
        loadLeadSourceData, rawLeadData,
        loadRawLeadData } = useCRMDataContext();

    const[res,setRes]=useState();
    // console.log(rawLeadData, 'rawLeadData');
    //  console.log(user?.userId, 'user')

    const postRawLead = async (leadId) => {
        const res = await postedRawLeads(leadId, user?.userId);
        if(res.status === 200){
             toast.success(`🦄 Posted Successfully`);
             loadRawLeadData();
        }
        console.log(res, 'res')
    }
   const filter=()=>{
        const filterdata=rawLeadData.filter(item=>item.posted!=="1");
        console.log(filterdata,"ahfiaskf");
        setRes(filterdata);
    }
    useEffect(() => {
        loadLeadSourceData()
        loadRawLeadData()
    }, [])
   useEffect(() => {
  if (rawLeadData.length > 0) {
    filter();
  }
}, [rawLeadData]);
    return (
        <>
            <div className="filter-bar mt-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap">

                    {/* Left Section */}
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                        {/* View Modes */}
                        <div className="btn-group" role="group">
                            <Button variant="outline-primary" className="active">
                                📌 Kanban
                            </Button>
                            <Button variant="outline-secondary">📋 Table</Button>
                            <Button variant="outline-secondary">🗂️ Cards</Button>
                        </div>

                        {/* Density Slider */}
                        <div className="d-flex align-items-center ms-3">
                            <span className="me-2 fw-semibold">Density:</span>
                            <Form.Range min="0" max="2" defaultValue="1" />
                            <span className="ms-2">Normal</span>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="d-flex align-items-center gap-2 mt-2 mt-md-0">
                        <Button variant="outline-primary">☑ Select All</Button>
                        <Button variant="outline-danger">❌ Clear</Button>
                    </div>
                </div>

                {/* Filter Inputs */}
                <div className="d-flex gap-3 mt-3 flex-wrap">
                    {/* Search */}
                    <Form.Control type="text" placeholder="Search leads..." className="filter-input" />

                    {/* Source */}
                    <Form.Select name="lead-source" className="filter-input">
                        <option>All Sources</option>
                        {leadSource.map((option) => (
                            <option key={option.codeId} value={option.codeId}>
                                {option.codeId} - {option?.sourceDescription}
                            </option>
                        ))}
                    </Form.Select>

                    {/* Assigned To */}
                    <Form.Select className="filter-input">
                        <option>All Assignees</option>
                        <option>John</option>
                        <option>Sarah</option>
                        <option>Team A</option>
                    </Form.Select>

                    {/* Date Range */}
                    <Form.Control type="date" className="filter-input" />
                    <Form.Control type="date" className="filter-input" />

                    {/* Apply Button */}
                    <Button className="btn-apply">
                        🔍 Apply Filters
                    </Button>
                </div>
            </div>

            <div className='raw-leads-table'>

                <Table bordered hover responsive className="data-table raw-lead-table">
                    <thead>
                        <tr>
                            <th>Raw Lead ID</th>
                            <th>Source</th>
                            <th>Name</th>
                            <th>Email Id.</th>
                            <th>Number</th>
                            <th>Social Media Link</th>
                            <th>Created At</th>
                            <th>Created By</th>
                            {/* <th>Updated At</th>
                            <th>Updated By</th> */}
                            <th>Action</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        {res?.length>0&&res.map((item, index) => (
                            <tr key={index}>
                                <td>{item?.rawLeadId}</td>
                                <td>{item.importSourceDescription}</td>
                                <td>{item.name}</td>
                                <td>{item.emailId
                                }</td>
                                <td>{item.number}</td>
                                <td><a href={item.socialMediaLink} target="_blank" rel="noopener noreferrer">{item.socialMediaLink}</a></td>
                                <td>{item.createdOnDate} at {item.createdOnTime}</td>
                                <td>{item.createdBy}</td>

                                {/* <td>{item.changedOnDate ? `${item.changedOnDate} at ${item?.changedOnTime}` : ''}</td>
                                <td>{item.changedBy
                                }</td> */}
                                <td className='action-boxes'>
                                    <Button onClick={() => postRawLead(item?.rawLeadId)} className="posted-btn">
                                        <FaCheck className="posted-icon" />
                                    </Button>
                                    <Link to={`/crm/update-rawlead/${item.rawLeadId}`} className="edit-link">
                                        <FaPencilAlt className="edit-icon" />
                                    </Link>

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

        </>
    )
}

export default RawLeadsMapping